import { useQuery } from '@tanstack/react-query';

import { getSeasonMissionDetail, getSeasonMissionParticipants, getSeasonMissions } from '../functions/seasonMissions';

export const useGetSeasonMissions = () =>
  useQuery({
    queryKey: ['get-season-missions'],
    queryFn: () => getSeasonMissions()
  });

export const useGetSeasonMissionDetail = (missionId: string) =>
  useQuery({
    queryKey: ['get-season-mission-detail'],
    queryFn: () => getSeasonMissionDetail({ missionId }),
    enabled: !!missionId
  });

export const useGetSeasonMissionParticipants = (missionId: string) =>
  useQuery({
    queryKey: ['get-season-mission-participants', missionId],
    queryFn: () => getSeasonMissionParticipants({ missionId }),
    enabled: !!missionId
  });
